const initState = {
    flujos:[],
    flujosTipo:[],
    message:'',
    conexion: false,
    error: false,
};

export default initState;